// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Widget Styles */

@keyframes bounce {
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-6px); }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(16px) scale(.97); }
  to   { opacity: 1; transform: none; }
}

.chat-panel {
  animation: slideUp .22s cubic-bezier(.2,.8,.2,1);
}

.chat-fab {
  transition: transform .15s, box-shadow .15s;
}

.chat-fab:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 24px rgba(0,0,0,0.35) !important;
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .chat-panel {
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    width: 100% !important;
    border-radius: 16px 16px 0 0 !important;
    height: 88vh !important;
  }
}

/* Chat message styles */
.chat-message {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.chat-message-label {
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-4);
}

.chat-message-bubble {
  max-width: 88%;
  border-radius: 4px 14px 14px 14px;
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.chat-message-bubble.user {
  background: var(--forest);
  color: #fff;
  border: none;
  border-radius: 14px 14px 4px 14px;
}

.chat-message-bubble.assistant {
  background: var(--card);
  color: var(--ink);
  border: 1px solid var(--hairline);
}

.chat-sources {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding-left: 2px;
  max-width: 90%;
}

.chat-source-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.chat-disclaimer {
  font-size: 10.5px;
  color: var(--ink-4);
  padding-left: 2px;
  max-width: 90%;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.chat-suggested-questions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding-left: 2px;
  max-width: 90%;
  margin-top: 2px;
}

.chat-suggested-btn {
  background: transparent;
  border: 1px solid var(--hairline);
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 11px;
  color: var(--forest);
  cursor: pointer;
  font-family: inherit;
  transition: all .15s;
}

.chat-suggested-btn:hover {
  background: var(--paper-2);
}

.chat-typing-indicator {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 12px;
}

.chat-typing-dots {
  background: var(--card);
  border: 1px solid var(--hairline);
  border-radius: 4px 14px 14px 14px;
  padding: 10px 14px;
  display: flex;
  gap: 5px;
  align-items: center;
}

.chat-typing-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ink-4);
  animation: bounce 1.2s ease-in-out infinite;
}

.chat-dot-0 { animation-delay: 0s; }
.chat-dot-1 { animation-delay: 0.2s; }
.chat-dot-2 { animation-delay: 0.4s; }

.chat-error {
  padding: 12px;
  background: rgba(139, 46, 46, 0.08);
  border: 1px solid rgba(139, 46, 46, 0.2);
  border-radius: 4px;
  color: var(--crimson);
  font-size: 13px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.chat-error-retry {
  background: var(--crimson);
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.chat-error-retry:hover {
  opacity: 0.9;
}

.chat-feedback-prompt {
  background: var(--paper-2);
  border: 1px solid var(--hairline);
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;
  font-size: 12px;
}

.chat-feedback-buttons {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.chat-feedback-btn {
  background: transparent;
  border: 1px solid var(--hairline);
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all .15s;
}

.chat-feedback-btn:hover {
  border-color: var(--forest);
  background: var(--paper-2);
}

.chat-feedback-btn.active {
  background: var(--forest);
  color: white;
  border-color: var(--forest);
}

.chat-history-empty {
  text-align: center;
  color: var(--ink-4);
  padding: 24px;
}

.chat-history-item {
  padding: 12px;
  border-bottom: 1px solid var(--hairline);
  cursor: pointer;
  transition: background .15s;
}

.chat-history-item:hover {
  background: var(--paper-2);
}

.chat-history-title {
  font-weight: 500;
  color: var(--ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-history-meta {
  font-size: 11px;
  color: var(--ink-4);
  margin-top: 4px;
}

.chat-history-delete {
  background: transparent;
  border: none;
  color: var(--crimson);
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/chat-widget.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,gBAAgB,wBAAwB,EAAE;EAC1C,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA,0BAA0B;AAC1B;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;IACvC,uBAAuB;EACzB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA,cAAc,mBAAmB,EAAE;AACnC,cAAc,qBAAqB,EAAE;AACrC,cAAc,qBAAqB,EAAE;;AAErC;EACE,aAAa;EACb,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["/* Chat Widget Styles */\n\n@keyframes bounce {\n  0%, 80%, 100% { transform: translateY(0); }\n  40% { transform: translateY(-6px); }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(16px) scale(.97); }\n  to   { opacity: 1; transform: none; }\n}\n\n.chat-panel {\n  animation: slideUp .22s cubic-bezier(.2,.8,.2,1);\n}\n\n.chat-fab {\n  transition: transform .15s, box-shadow .15s;\n}\n\n.chat-fab:hover {\n  transform: scale(1.08);\n  box-shadow: 0 6px 24px rgba(0,0,0,0.35) !important;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 480px) {\n  .chat-panel {\n    bottom: 0 !important;\n    right: 0 !important;\n    left: 0 !important;\n    width: 100% !important;\n    border-radius: 16px 16px 0 0 !important;\n    height: 88vh !important;\n  }\n}\n\n/* Chat message styles */\n.chat-message {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.chat-message-label {\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-4);\n}\n\n.chat-message-bubble {\n  max-width: 88%;\n  border-radius: 4px 14px 14px 14px;\n  padding: 10px 14px;\n  font-size: 13px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.chat-message-bubble.user {\n  background: var(--forest);\n  color: #fff;\n  border: none;\n  border-radius: 14px 14px 4px 14px;\n}\n\n.chat-message-bubble.assistant {\n  background: var(--card);\n  color: var(--ink);\n  border: 1px solid var(--hairline);\n}\n\n.chat-sources {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding-left: 2px;\n  max-width: 90%;\n}\n\n.chat-source-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.chat-disclaimer {\n  font-size: 10.5px;\n  color: var(--ink-4);\n  padding-left: 2px;\n  max-width: 90%;\n  line-height: 1.5;\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.chat-suggested-questions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding-left: 2px;\n  max-width: 90%;\n  margin-top: 2px;\n}\n\n.chat-suggested-btn {\n  background: transparent;\n  border: 1px solid var(--hairline);\n  border-radius: 999px;\n  padding: 3px 10px;\n  font-size: 11px;\n  color: var(--forest);\n  cursor: pointer;\n  font-family: inherit;\n  transition: all .15s;\n}\n\n.chat-suggested-btn:hover {\n  background: var(--paper-2);\n}\n\n.chat-typing-indicator {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.chat-typing-dots {\n  background: var(--card);\n  border: 1px solid var(--hairline);\n  border-radius: 4px 14px 14px 14px;\n  padding: 10px 14px;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n.chat-typing-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--ink-4);\n  animation: bounce 1.2s ease-in-out infinite;\n}\n\n.chat-dot-0 { animation-delay: 0s; }\n.chat-dot-1 { animation-delay: 0.2s; }\n.chat-dot-2 { animation-delay: 0.4s; }\n\n.chat-error {\n  padding: 12px;\n  background: rgba(139, 46, 46, 0.08);\n  border: 1px solid rgba(139, 46, 46, 0.2);\n  border-radius: 4px;\n  color: var(--crimson);\n  font-size: 13px;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.chat-error-retry {\n  background: var(--crimson);\n  color: white;\n  border: none;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.chat-error-retry:hover {\n  opacity: 0.9;\n}\n\n.chat-feedback-prompt {\n  background: var(--paper-2);\n  border: 1px solid var(--hairline);\n  border-radius: 8px;\n  padding: 12px;\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.chat-feedback-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.chat-feedback-btn {\n  background: transparent;\n  border: 1px solid var(--hairline);\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all .15s;\n}\n\n.chat-feedback-btn:hover {\n  border-color: var(--forest);\n  background: var(--paper-2);\n}\n\n.chat-feedback-btn.active {\n  background: var(--forest);\n  color: white;\n  border-color: var(--forest);\n}\n\n.chat-history-empty {\n  text-align: center;\n  color: var(--ink-4);\n  padding: 24px;\n}\n\n.chat-history-item {\n  padding: 12px;\n  border-bottom: 1px solid var(--hairline);\n  cursor: pointer;\n  transition: background .15s;\n}\n\n.chat-history-item:hover {\n  background: var(--paper-2);\n}\n\n.chat-history-title {\n  font-weight: 500;\n  color: var(--ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-history-meta {\n  font-size: 11px;\n  color: var(--ink-4);\n  margin-top: 4px;\n}\n\n.chat-history-delete {\n  background: transparent;\n  border: none;\n  color: var(--crimson);\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
